import React from 'react';
import { useAppUserDefaultStore, isAllRestaurantsSelected } from '../../../../stores/appUserDefaultStore';
import { useParams, Navigate } from 'react-router-dom';
import { ReportsGate } from './ReportsGate';
import { ReportDetailLayout } from './ReportDetailLayout';
import { getReportDefinition } from './reportsRegistry';

/**
 * Renders a single report at `/reports/:reportKey`. Resolves the report from the
 * registry, wraps it in the access gate + shared layout, and redirects unknown
 * keys back to the hub.
 */
const ReportDetailRoute: React.FC = () => {
  const { reportKey } = useParams<{ reportKey: string }>();
  const restaurant = useAppUserDefaultStore(s => s.restaurant);
  const definition = getReportDefinition(reportKey);

  if (!definition) return <Navigate to="/reports" replace />;

  const { Component } = definition;

  return (
    <ReportsGate requireSingleRestaurant={!definition.supportsAllRestaurants}>
      <ReportDetailLayout independentHistory={definition.key === 'utilization' && isAllRestaurantsSelected(restaurant)} titleKey={definition.titleKey} overallTypeOptions={definition.overallTypeOptions}>
        <Component />
      </ReportDetailLayout>
    </ReportsGate>
  );
};

export default ReportDetailRoute;
